const operatorLocale = {
  operator: {
    openedFolders: "Dossiers ouverts",
    openedFoldersN: "Dossiers ouverts ({n})",
  },
};

export type OperatorLocale = typeof operatorLocale;
export default operatorLocale;
